import { CommentOwnerHeaderProps } from './CommentOwnerHeader';
import { EventOwnerHeaderProps } from './EventOwnerHeader';
import i18next from '../../../i18n';

export const getCommentOwnerHeaderDisplayUsername = ({
  isOwned,
  ownerUsername,
  ownerType,
}: Pick<
  CommentOwnerHeaderProps,
  'isOwned' | 'ownerUsername' | 'ownerType'
>) => {
  const who = getEventOwnerHeaderDisplayUsername({
    isOwned,
    ownerUsername,
    ownerType,
  });
  return `${who} (Posted this Alert)`;
};

export const getEventOwnerHeaderDisplayUsername = ({
  isOwned,
  ownerUsername,
  ownerType,
}: Pick<EventOwnerHeaderProps, 'isOwned' | 'ownerUsername' | 'ownerType'>) => {
  if (isOwned) {
    return i18next.t('me', { ns: 'common' });
  }
  return ownerType === 'neighbor'
    ? ownerUsername.replace('Neighbor', () =>
        i18next.t('neighbor', { ns: 'common' }),
      )
    : ownerUsername;
};
